import en from 'translations/en/popularProductForm.json';
import pl from 'translations/pl/popularProductForm.json';
import sl from 'translations/sl/popularProductForm.json';
import { ITranslations } from 'types/common';
import { PopularProductFormTransFields } from './types';

export const popularProductFormTranslations: ITranslations<PopularProductFormTransFields> = {
  name: 'popularProductForm',
  en,
  pl,
  sl,
};
